let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cks9H")).then(() => parcelRequire('1NTSU'));